import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-loansummaryreport',
  templateUrl: './loansummaryreport.component.html',
  styleUrls: ['./loansummaryreport.component.css']
})
export class LoansummaryreportComponent implements OnInit {

  @ViewChild('filterbar',{static:false}) filterbar;

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "LoanSummaryReport";

  fromdate: any = new Date();
  todate: any = new Date();

  filterstatus: string = "ALL";
  dtOptions: DataTables.Settings = {};
    
  loansummaryColl:any=[];


  searchtxt: any = "";


  columnDefs = [
    {
      headerName: 'Loan Date', field: 'transdt', type:'date' 
    },
    { headerName: 'Employee', field: 'empname' },
    { headerName: 'Loan Type', field: 'loantype',  filter: true },       
    { headerName: 'Loan Amount', field: 'amount', type:'decimal' },
    { headerName: 'Installment', field: 'installments' },
    { headerName: 'Installment Amount', field: 'installmentsamount',type:'decimal'},
    { headerName: 'Status', field: 'approvedstatus' },
    { headerName: 'Payment Status', field: 'paymentstatus' }
  
    ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  }; 

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor( private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,private datePipe: DatePipe,private productFindService: NgbModal,) {
      this.fnServiceChanges();

      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
      this.fromdate.setDate(this.fromdate.getDate() - 15);
  }
  
  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm(){
    this.fngetLoanSummaryReport();     
  }


  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }



 
  

    fnActionExportClick()  {
        const params = {
          columnGroups: true,
          allColumns: true,
          fileName: 'LoanSummarylist',
          //columnSeparator: document.querySelector("#columnSeparator").value
        };
      
    }
    fnActionFilterClick() {  

      this.filterbar.filterstatus = this.filterstatus;
      
      this.isfilter = !this.isfilter;
    }
    fnActionRefreshClick() { 
      this.fngetLoanSummaryReport()
    }
    fnApplyFilter(data) {
     // this.isfilter = !this.isfilter;
  
      this.filterstatus = data;
  
      this.fngetLoanSummaryReport();
       
    }
  
    fnCurrentRouteChange() { 
      var queryParams = {};
      
  
      if (this.filterstatus != '') {     
        queryParams['status'] = this.filterstatus;
      }   
  
       this.router.navigate(
        [], 
        {
          relativeTo: this.route,
          queryParams: queryParams, 
        
        });
    }
    
    
  
  
  //Get
  fngetLoanSummaryReport() {
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();       
      var data = {
          'loanid':0,
          'companyid': this.loginService.fnGetCompanyId(),  
          'filterstatus':this.filterstatus  ,
          'fromdate':this.fnFormatDatetime(this.fromdate),
          'todate':this.fnFormatDatetime(this.todate),                                                                         
          
      }
      this.appService.getLoanSummaryReport(data)
      .subscribe(
          (res)=>{                  
            if(res.json().status===200){
              this.fnHideProgress();                   

              this.loansummaryColl = res.json().result;   
              this.fnSetTable();
            this.fnCurrentRouteChange();        
              
            }else {
              this.fnHideProgress();                   

                this.loginService.fnAPIError(res.json())
            }             
          },
          (err)=>{  
            this.fnHideProgress();                   
        
              this.toastr.error('Error', err);
      })
  }
  


  
  


  fnSetTable() {
    
  }

  public fnSearchDatatable(value){    
    
  }

  private fnFocusTableRow(index,status){
    if(index>-1){
      if(status==='IN'){          
        this.loansummaryColl[index].hoverfocus="IN"
      }
      else{
        this.loansummaryColl[index].hoverfocus=""
      }                
    }    
}
  
  
fnFormatDecimal(params) {
  if (params.value) {
    return params.value.toFixed(2)
  }
}

fnMomentDateFormatter(params) {
  if (params.value) {
    return moment(params.value).format('DD-MM-YYYY');//  
  }
  else {
    return '';
  }

}

fnConvertDatetime(dt) {
  if (dt) {
    if (dt === "") {
      return null
    }
    else {
      var dateParts = dt.split("-");
      var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
      sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
      return sdate;
    }

  } else {
    return null
  }
}

fnFormatDatetime(dt) {
  if (dt) {
    if (dt === "") {
      return null
    }
    else {
      return this.datePipe.transform(dt, "yyyy-MM-dd")
    }

  } else {
    return null
  }

}

fngetDescriptionRefno(data){
  var rtnstr="";
  try{
      if(data.transdt){
        rtnstr=rtnstr+data.transdt;
      }

      if(data.empid){
        rtnstr=rtnstr+" - "+data.empid;
      }

      if(data.empname){
        rtnstr=rtnstr+" - "+data.empname;
      }
    }catch{
    
    }
  return rtnstr;
}
fnCloseForm(){
  try{
    this.router.navigate(['/Reports']);
  }catch(ex){
     this.fnShowErrorMsg(ex);
  }
  }
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.loansummaryColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  } 


fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
} 
  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }








}
